module.exports = __webpack_public_path__ + "img/price2.52de6dd5.png";